<template>
	<div id="app">
		<!-- <keep-alive exclude=""> -->
			<router-view v-if="!platform_pc"></router-view>
			<template v-if="platform_pc">
				<keep-alive exclude="products-info">
					<router-view></router-view>
				</keep-alive>
			</template>
		<!-- </keep-alive> -->
	</div>
</template>

<script>
export default {
	name: 'app',
	components: {},
	data: function () {
		return {
			platform_pc: null,  //pc
		}
	},
	created(){
		let isiPad = (navigator.userAgent.match(/(iPad)/) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));
		if(/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) || isiPad) {
			this.platform_pc = true;
		}else {
			this.platform_pc = false;
		}
	},
	mounted() {
		//
	}
}
</script>
<style>
@charset "utf-8";
::-webkit-input-placeholder{color:#999999;}
/* ::-webkit-scrollbar{display:none;width:0 !important;height:0 !important;-webkit-appearance:none;background:transparent;} */
*{
	font-family: "Microsoft YaHei", "Helvetica", 'Arial';
	outline:none;
	text-decoration:none;
	box-sizing:border-box;
	-webkit-tap-highlight-color:rgba(0,0,0,0);
	touch-action: pan-y;
	word-wrap: normal;letter-spacing: 0px;
	font-size: 14px;
	/* color: #272E3B */
	/* word-break: break-all; */
}
img{vertical-align:top;}
html,body{width:100%;height:100%;margin:0px;padding:0px;-webkit-overflow-scrolling: touch;}
input,div,span,select,textarea,button{line-height: normal;}
input{-webkit-appearance: none;}
textarea { resize: none; } 
/*公共按钮*/
.public_btn{
	display: inline-block;
	padding: 8px 36px;
	font-size: 16px;
	color: #ffffff;
	background-color: #0064A4;
	border-radius: 22px;
	cursor: pointer;
}
.public_btn .icon{
	top: 1px;
	margin-left: 8px;
	transform: rotate(-90deg);
}
.van-toast .van-toast__text{
	color: #ffffff;
}
/*loading*/
.loading{width:100%;height:100%;position:fixed;display:flex;justify-content:center;align-items:center;top:0;right:0;bottom:0;left:0;background:#ffffff;z-index:999;}
.select_popper {
	z-index: 99999 !important;
}
.warning-row{
	background-color: #fdf5e6 !important;
}
/* .addedit_box{
	z-index: 50000 !important;
} */
</style>